const CryptoJS = require('crypto-js')

class Encrypt {
  constructor () {
    this.tokenKey = '$2a$14$MsHXHFh2C47t1Yh7XWvbdu6sNXSsrwhczUmndm6MJfWyNVFqJYEMW'
  }

  encodeToken (item) {
    return CryptoJS.AES.encrypt(item, this.tokenKey)
  }

  decodeToken (item) {
    const bytes = CryptoJS.AES.decrypt(item, this.tokenKey)
    return bytes.toString(CryptoJS.enc.Utf8)
  }

  encodeDate (date) {
    return CryptoJS.AES.encrypt(JSON.stringify(date), this.tokenKey)
  }

  decodeDate (date) {
    const bytes = CryptoJS.AES.decrypt(date, this.tokenKey)
    return bytes.toString(CryptoJS.enc.Utf8)
  }


  encodeUser (item) {
    return CryptoJS.AES.encrypt(JSON.stringify(item), this.tokenKey)
  }

  decodeUser (item) {
    const bytes = CryptoJS.AES.decrypt(item, this.tokenKey)
    return bytes.toString(CryptoJS.enc.Utf8)
  }
}
export default new Encrypt()